import { ExternalDeliveryProviders } from 'src/constants/ExternalDeliveryProviders';
import type { OrderVm } from 'src/types/OrderVm';

export function isRappiDelivery(order: OrderVm): boolean {
    return order.externalDeliveryProvider === ExternalDeliveryProviders.RAPPI_CARGO;
}
